__turbopack_context__.v({
  "empty": "HFco_q_empty",
  "grid": "HFco_q_grid",
  "heading": "HFco_q_heading",
  "loading": "HFco_q_loading",
  "pagination": "HFco_q_pagination",
  "section": "HFco_q_section",
  "visuallyHidden": "HFco_q_visuallyHidden",
});
